import {z} from "zod";

export const loginSchema = z.object({
  user_name: z.string().min(1, {message: "Username is required"}),
  password: z.string().min(1, {message: "Password is required"}),
  remember_me: z.boolean().optional().default(false),
  gps_coordinates: z.string().optional(),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email({message: "Invalid email address"}),
});

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1, {message: "Token is required"}),
    password: z.string().min(1, {message: "Password is required"}),
    password_confirm: z.string().min(1, {message: "Password confirm is required"}),
  })
  .refine((data) => data.password === data.password_confirm, {
    message: "Passwords do not match",
    path: ["password_confirm"],
  });

export const changePasswordSchema = z
  .object({
    password: z.string().min(1, {message: "Password is required"}),
    password_confirm: z.string().min(1, {message: "Password confirm is required"}),
  })
  .refine((data) => data.password === data.password_confirm, {
    message: "Passwords do not match",
    path: ["password_confirm"],
  });

export const completePlaceholderProfileSchema = z.object({
  first_name: z
    .string()
    .trim()
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be at most 50 characters"),
  last_name: z
    .string()
    .trim()
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be at most 50 characters"),
  telephone: z.string().trim().max(20, "Phone must be at most 20 characters").optional(),
});
